// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { cloudUpload16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-cloud-upload': IconCloudUpload;
    }
}

/**
 * The icon component for the 'cloudUpload' icon
 */
export class IconCloudUpload extends Icon {
    public constructor() {
        super(cloudUpload16X16);
    }
}

registerIcon('icon-cloud-upload', IconCloudUpload);
export const iconCloudUploadTag = 'nimble-icon-cloud-upload';
